// @ts-nocheck
const isDevelopment = process.env.NODE_ENV === "development";
const developmentApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL_DEV ||
  process.env.NEXT_PUBLIC_API_BASE_URL_DEV ||
  "http://localhost:7500";
const productionApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.NEXT_PUBLIC_API_BASE_URL ||
  "https://api.premiumblognews.com";
const publicShareBaseUrl =
  process.env.REACT_APP_PUBLIC_SHARE_BASE_URL ||
  process.env.NEXT_PUBLIC_PUBLIC_SHARE_BASE_URL ||
  (isDevelopment ? developmentApiBaseUrl : productionApiBaseUrl);

const API = {
  BASE_URL: isDevelopment
    ? developmentApiBaseUrl
    : productionApiBaseUrl,
  SHARE_BASE_URL: publicShareBaseUrl,
};
 
 export default API;
